import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';

import moment from 'moment/moment';
import { ordersSelector } from '../../../../redux/selectors/orders';

import Alert from '../../../../components/Alert';

const SellingAlert = () => {
  const {
    selling_at_lost,
  } = useSelector((state) => ordersSelector(state));

  const [showSellingAlert, setShowSellingAlert] = useState(false);

  const onDismissSelling = () => {
    localStorage.setItem('sellingAlert', new Date().toISOString());
  };

  useEffect(() => {
    if (!isEmpty(selling_at_lost)) {
      if (!localStorage.getItem('sellingAlert')) {
        setShowSellingAlert(true);
      }
      const lastClose = moment(new Date(localStorage.getItem('sellingAlert')));
      const diff = lastClose.diff(moment(new Date()), 'days');
      if (diff !== 0) {
        setShowSellingAlert(true);
        localStorage.removeItem('sellingAlert');
      }
    }
  }, [selling_at_lost]);

  if (!showSellingAlert) {
    return null;
  }

  return (
    <Alert onDismiss={onDismissSelling} dismiss tooltipOnClose classNames="text-center">
      {selling_at_lost?.text}
      {' '}
      <Link to={selling_at_lost?.link?.replace('/admin', '')} style={{ color: '#a94442', textDecoration: 'underline' }}>
        {selling_at_lost?.link_text}
      </Link>
    </Alert>
  )
}

export default SellingAlert;
